import { LegalPage, LegalSection } from "@/pages/legal/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Confidentialite() {
  return (
    <LegalPage
      testId="page-confidentialite"
      title="Politique de confidentialité"
      updated="Juillet 2025"
      seoDescription="Politique de confidentialité et protection des données personnelles (RGPD) de PlanPermis."
    >
      <p>
        La présente politique décrit la manière dont PlanPermis collecte et traite vos données personnelles,
        conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
      </p>

      <LegalSection title="1. Responsable de traitement">
        <p>
          Le responsable de traitement est {COMPANY.legalName}, {COMPANY.address}, joignable à {COMPANY.email}.
        </p>
      </LegalSection>

      <LegalSection title="2. Données collectées">
        <p>
          Nous collectons les données que vous nous fournissez via le formulaire : nom, prénom, email, téléphone,
          ville, code postal, type de permis, préférence de zone (ville / campagne), délai souhaité, ainsi que, le cas échéant, le nom de votre
          ancienne auto-école et votre avis. Des données techniques (source d'acquisition, page d'origine) peuvent
          également être collectées.
        </p>
      </LegalSection>

      <LegalSection title="3. Finalités">
        <p>
          Vos données sont utilisées pour étudier votre demande et vous mettre en relation avec une ou plusieurs
          auto-écoles partenaires, ainsi que pour améliorer notre service.
        </p>
      </LegalSection>

      <LegalSection title="4. Base légale">
        <p>
          Le traitement repose sur votre consentement, recueilli lors de l'envoi du formulaire. Vous pouvez le retirer
          à tout moment.
        </p>
      </LegalSection>

      <LegalSection title="5. Destinataires">
        <p>
          Vos coordonnées peuvent être transmises aux auto-écoles partenaires du réseau, uniquement dans le but de
          vous recontacter au sujet de votre demande. Elles ne sont jamais vendues à des tiers à des fins publicitaires.
        </p>
      </LegalSection>

      <LegalSection title="6. Durée de conservation">
        <p>
          Vos données sont conservées le temps nécessaire au traitement de votre demande, puis archivées ou supprimées
          conformément aux durées légales applicables.
        </p>
      </LegalSection>

      <LegalSection title="7. Vos droits">
        <p>
          Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation et de
          portabilité de vos données. Pour les exercer, contactez {COMPANY.email}. Vous pouvez
          également introduire une réclamation auprès de la CNIL (www.cnil.fr).
        </p>
      </LegalSection>

      <LegalSection title="8. Cookies et pixels publicitaires">
        <p>
          Le site utilise des cookies de mesure d'audience et des pixels publicitaires (Facebook/Meta, Google,
          TikTok) destinés à mesurer l'efficacité de nos campagnes. Ces traceurs ne sont déposés et déclenchés
          qu'<strong>après votre consentement explicite</strong>, recueilli via le bandeau affiché lors de votre
          première visite. Vous pouvez refuser ces traceurs sans conséquence sur l'accès au service, et modifier
          votre choix à tout moment en effaçant les données de navigation de votre navigateur. Les cookies
          strictement nécessaires au fonctionnement du site ne requièrent pas de consentement.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
